import { z } from 'zod';

export enum CONTENT_ASSET_KEYS {
    CART_DELIVERY_POPUP = 'CART-DELIVERY-POPUP',
}

const operators = z.union([
    z.object({
        name: z.literal('setText'),
        value: z.string(),
    }),
    z.object({
        name: z.literal('setAttribute'),
        value: z.object({ name: z.string(), value: z.string() }),
    }),
    z.object({
        name: z.literal('removeAttribute'),
        value: z.string(),
    }),
    z.object({
        name: z.literal('addClass'),
        value: z.string(),
    }),
    z.object({
        name: z.literal('removeClass'),
        value: z.string(),
    }),
    z.object({
        name: z.literal('removeSelf'),
    }),
    z.object({
        name: z.literal('getText'),
    }),
]);

const transformer = z.object({
    selectors: z.array(
        z.object({
            name: z.string(),
            operators: z.array(operators),
        }),
    ),
});

export const ContentAssetDTO = z.object({
    'content-assets': z.record(z.nativeEnum(CONTENT_ASSET_KEYS), transformer),
});

export type ContentAssetDTO = z.infer<typeof ContentAssetDTO>;
export type ContentAssetOperators = z.infer<typeof operators>;
export type ContentAssetTransformer = z.infer<typeof transformer>;
